import { useEffect, useRef, useState } from "react";
import classes from "./CreateNewEvent.module.css";
import { v4 as uuidv4 } from "uuid";

import {
  ActionButton,
  Container,
  Icon,
  InputDate,
  InputDropdown,
  InputField,
  Notifications,
  Text,
} from "@jds/core";
import EventBannerInput from "../UI/Form/eventBannerInput/EventBannerInput";
import { useDispatch, useSelector } from "react-redux";
import useInput from "../../hooks/use-input";
import { validateTextInput } from "../../util/validation";
import decryptUrl from "../../util/img-decryption";
import {
  addParamsURL,
  convertDateFormat,
  convertRailwayTimeToStandardTime,
  isValidDateRange,
  isValidYYYYMMDD,
} from "../../util/helper";
import useApiHttp from "../../hooks/use-http";
import JdsModal from "../UI/JdsModal";
import { Box } from "@mui/material";
import ImageGrid from "../Layout/ImageGrid";
import CustomeTimePicker from "../UI/Form/customeTimePicker/CustomeTimePicker";
import LocationInput from "../UI/Form/LocationInput";
import DynamicForm from "../DynamicFrom/DynamicForm";
import Lottie from "lottie-react";
import cloudLogo from "../../assets/lottie/cloud.json";
import dayjs from "dayjs";
import { eventListTrigger } from "../../store/state-slices/apiTrigger";

const CreateNewEvent = ({
  vendorEventId,
  setSuccessModal,
  setEventId,
  closeModal,
}) => {
  const profileDetailsRedux = useSelector(
    (state) => state.profileDetails.profileDetails,
  );
  const dispatch = useDispatch();
  const formSectionRef = useRef(null);
  const [formStep, setFormStep] = useState(1);

  const [bannerImage, setBannerImage] = useState(null);
  const [eventTypeList, setEventTypeList] = useState([]);

  const [eventTypeImageId, setEventTypeImageId] = useState(null);
  const [defaultBanner, setDefaultBanner] = useState(null);
  const [eventImgDefault, setEventImgDefault] = useState(null);
  const [currentIndex, setCurrIndex] = useState(null);
  const [isEventTypeGalleryModalClose, setIsEventTypeGalleryModalClose] =
    useState(true);

  const [locationData, setLocationData] = useState({});

  const [isOpenEvent, setIsOpenEvent] = useState(true);
  const [defaultAccess, setDefaultAccess] = useState("FACE_ACCESS");
  const [defaultUploadAccess, setDefaultUploadAccess] = useState("APPROVED");
  const [defaultDownloadAccess, setDefaultDownloadAccess] =
    useState("APPROVED");
  const [defaultDynamicField, setDefaultDynamicField] = useState([]);

  const { sendRequest: getEventTypeList, isLoading: eventListGeting } =
    useApiHttp();
  const { sendRequest: createEvent, isLoading: eventCreating } = useApiHttp();

  const {
    value: bannerImg,
    isValid: bannerImgIsValid,
    hasError: bannerImgHasError,
    valueChangeHandler: bannerImgChangeHandler,
    inputBlurHandler: bannerImgBlurHandler,
    reset: resetBannerImgInput,
  } = useInput((data) => {
    return typeof data === "object" ? true : false;
  });

  const {
    value: selectedEventType,
    isValid: selectedEventTypeIsValid,
    hasError: selectedEventTypeHasError,
    valueChangeHandler: eventTypeChangeHandler,
    inputBlurHandler: eventTypeBlurHandler,
    reset: resetEventTypeInput,
  } = useInput(validateTextInput);

  const {
    value: enteredEventName,
    isValid: enteredEventNameIsValid,
    hasError: enteredEventNameHasError,
    valueChangeHandler: eventNameChangeHandler,
    inputBlurHandler: eventNameBlurHandler,
    reset: resetEventNameInput,
  } = useInput(validateTextInput);

  const {
    value: startDate,
    isValid: startDateIsValid,
    hasError: startDateHasError,
    valueChangeHandler: startDateChangeHandler,
    inputBlurHandler: startDateBlurHandler,
    reset: resetStartDateInput,
  } = useInput((dateStr) => {
    const regex = /^\d{4}[-/]\d{2}[-/]\d{2}$/;
    if (!regex.test(dateStr)) return false;
    const [yyyy, mm, dd] = dateStr?.replace(/-/g, "/")?.split("/").map(Number);
    if (mm < 1 || mm > 12 || dd < 1 || dd > 31) return false;
    const date = new Date(yyyy, mm - 1, dd);
    return (
      date.getFullYear() === yyyy &&
      date.getMonth() === mm - 1 &&
      date.getDate() === dd
    );
  });

  const {
    value: endDate,
    isValid: endDateIsValid,
    hasError: endDateHasError,
    valueChangeHandler: endDateChangeHandler,
    inputBlurHandler: endDateBlurHandler,
    reset: resetEndDateInput,
  } = useInput((dateStr) => {
    const regex = /^\d{4}[-/]\d{2}[-/]\d{2}$/;
    if (!regex.test(dateStr)) return false;
    const [yyyy, mm, dd] = dateStr?.replace(/-/g, "/")?.split("/").map(Number);
    if (mm < 1 || mm > 12 || dd < 1 || dd > 31) return false;
    const date = new Date(yyyy, mm - 1, dd);
    return (
      date.getFullYear() === yyyy &&
      date.getMonth() === mm - 1 &&
      date.getDate() === dd
    );
  });

  const {
    value: time,
    isValid: timeIsValid,
    hasError: timeHasError,
    valueChangeHandler: timeChangeHandler,
    inputBlurHandler: timeBlurHandler,
    reset: resetTimeInput,
  } = useInput((data) => {
    const date = new Date(data);
    if (Object.prototype.toString.call(date) === "[object Date]") {
      if (isNaN(date.getTime())) {
        return false;
      } else {
        return true;
      }
    }
  });

  const {
    value: location,
    isValid: locationIsValid,
    hasError: locationHasError,
    valueChangeHandler: locationChangeHandler,
    inputBlurHandler: locationBlurHandler,
    reset: resetLocationInput,
  } = useInput(validateTextInput);
  const culumData = (data) => {
    setEventTypeList(data?.data?.results);
    if (profileDetailsRedux?.userType === "SCHOOL") {
      eventTypeChangeHandler({ target: { value: data?.data?.results[0]?.id } });

      const selectedEvent = data?.data?.results || [];
      const defaultBanner = selectedEvent[0]?.imageList[0]?.image;
      const defaultBannerId = selectedEvent[0]?.imageList[0]?.id;

      setEventTypeImageId(defaultBannerId);
      setDefaultBanner(decryptUrl(defaultBanner));
      setEventImgDefault(decryptUrl(defaultBanner));
      if (selectedEvent[0]?.name === "School") {
        setDefaultDynamicField([
          {
            id: uuidv4(),
            type: "text",
            questionName: "Parent Name",
            required: true,
          },
          {
            id: uuidv4(),
            type: "dropdown",
            questionName: "Grade",
            required: true,
            options: [
              "Nursery",
              "LKG",
              "UKG",
              "I",
              "II",
              "III",
              "IV",
              "V",
              "VI",
              "VII",
              "VIII",
              "IX",
              "X",
              "XI",
              "XII",
            ],
          },
          {
            id: uuidv4(),
            type: "text",
            questionName: "Roll Number",
            required: true,
          },
        ]);
      }
    }
  };

  const chooseEventImgClickHandler = () => {
    if (!selectedEventType) {
      Notifications.toast.error({
        title: "Please select event type",
        id: "choose event image",
      });
      return;
    }
    const selectedEventTypeData = eventTypeList
      ?.find((val) => val.id === selectedEventType)
      ?.imageList.map((data) => ({
        thumbnailFileSignedPath: addParamsURL(decryptUrl(data?.image), {
          size: "s",
        }),
      }));
    setIsEventTypeGalleryModalClose(false);
  };

  const eventBannerGalleryModalCloseHandler = () => {
    setIsEventTypeGalleryModalClose(true);
    setCurrIndex(null);
  };

  const handleCreateEvent = () => {
    const eventTypeLabel = eventTypeList.filter(
      (item) => item.id === selectedEventType,
    )[0]?.name;
    let formatTime = dayjs(time).format("HH:mm:ss");
    const formData = new FormData();
    formData.append("locationLongitude", locationData?.lng);
    formData.append("locationLatitude", locationData?.lat);
    formData.append("eventType", selectedEventType);
    formData.append("eventTypeName", eventTypeLabel);
    formData.append("name", enteredEventName);
    formData.append("startDate", convertDateFormat(startDate));
    formData.append("endDate", convertDateFormat(endDate));
    formData.append("locationName", locationData?.name || location);
    formData.append("locationState", locationData?.state || "");
    formData.append("isAutoApproval", isOpenEvent);
    formData.append("defaultAccess", defaultAccess);
    formData.append("defaultDownloadAccess", defaultDownloadAccess);
    formData.append("defaultUploadAccess", defaultUploadAccess);
    eventTypeImageId && formData.append("eventTypeImageId", eventTypeImageId);
    if (vendorEventId && vendorEventId !== "null") {
      formData.append("vendorEventId", vendorEventId);
    }
    formData.append(
      "time",
      startDate === endDate
        ? convertRailwayTimeToStandardTime(formatTime)
        : null,
    );
    formData.append("bannerimage", bannerImg || null);
    formData.append("customField", JSON.stringify(defaultDynamicField));

    createEvent(
      {
        url: "event/create_event",
        method: "POST",
        body: formData,
        formData: true,
      },
      null,
      (data) => {
        if (data?.statusCode === 201) {
          setSuccessModal(false);
          setEventId(data?.data?.id);
          dispatch(eventListTrigger());
          closeModal();
        }
      },
      (err, data) => {
        Notifications.toast.error({
          title: data?.message,
          id: "create-event",
        });
      },
    );
  };

  const formSubmitHandler = async (e) => {
    eventTypeBlurHandler(enteredEventName);
    eventNameBlurHandler(selectedEventType);
    startDateBlurHandler(startDate);
    endDateBlurHandler(endDate);
    locationBlurHandler(location);
    timeBlurHandler(time);
    if (!defaultBanner) {
      bannerImgBlurHandler(bannerImg);
    }

    const dateCheck = startDate === endDate ? timeIsValid : true;

    if (
      selectedEventTypeIsValid &&
      enteredEventNameIsValid &&
      startDateIsValid &&
      endDateIsValid &&
      locationIsValid &&
      locationData?.name &&
      locationData?.lat &&
      locationData?.lng &&
      dateCheck
    ) {
      setFormStep((pre) => pre + 1);
    } else {
    }
  };

  useEffect(() => {
    getEventTypeList(
      {
        url: `event-types/get-all`,
        method: "GET",
      },
      culumData,
    );
  }, []);
  useEffect(() => {
    if (formSectionRef.current) {
      formSectionRef.current.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [formStep]);
  return (
    <>
      <div
        className={`${classes["form-position"]}`}
        style={{
          "--color-primary-20": "#e5f1f7ff",
          "--color-primary-30": "#89dcffff",
          "--color-primary-40": "#67c3efff",
          "--color-primary-50": "#0078adff",
          "--color-primary-60": "#0078adff",
          "--color-primary-70": "#00364eff",
          "--color-primary-80": "#001e2bff",

          maxWidth: "680px",
        }}>
        <div className={`${classes["form-container"]}`}>
          <div className={`${classes["form-header"]}`}>
            <div className={`${classes["header-title"]}`}>
              <p>Create New Event</p>
              <Icon
                ic={"IcClose"}
                onClick={() => {
                  closeModal();
                }}
              />
            </div>
            <div className={`${classes["step-container"]}`}>
              <div className={`${classes["step-line"]}`}>
                <div
                  className={`${classes["step-line-active"]}`}
                  style={{
                    width:
                      formStep == 3 ? "100%" : formStep == 2 ? "50%" : "0%",
                  }}></div>
              </div>
              <div className={`${classes["step-item"]}`}>
                <div
                  className={`${classes["step-info"]} ${formStep == 1 && classes["active"]} ${formStep > 1 && classes["complete"]} `}>
                  <div className={`${classes["step-icon"]}`}>
                    <Icon ic={"IcCelebration"} kind="background" size="large" />
                  </div>
                  <div className={`${classes["step-title"]}`}>Event Detail</div>
                </div>
                <div
                  className={`${classes["step-info"]} ${formStep == 2 && classes["active"]} ${formStep > 2 && classes["complete"]}`}>
                  <div className={`${classes["step-icon"]}`}>
                    <Icon ic={"IcLock"} kind="background" size="large" />
                  </div>
                  <div className={`${classes["step-title"]}`}>Event Access</div>
                </div>
                <div
                  className={`${classes["step-info"]} ${formStep == 3 && classes["active"]} `}>
                  <div className={`${classes["step-icon"]}`}>
                    <Icon ic={"IcForm"} kind="background" size="large" />
                  </div>
                  <div className={`${classes["step-title"]}`}>
                    {profileDetailsRedux?.userType === "SCHOOL"
                      ? "Student Information Form"
                      : "Guest Information Form"}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className={`${classes["form-section"]}`}
            style={
              formStep === 3
                ? {
                  display: "flex",
                }
                : {}
            }
            ref={formSectionRef}>
            {eventListGeting ||
              (eventCreating && (
                <div className={`${classes["modal-loader"]}`}>
                  <div className={`${classes["loader-icon"]}`}>
                    <Lottie
                      animationData={cloudLogo}
                      loop={true}
                      autoplay={true}
                    />
                  </div>
                </div>
              ))}
            {formStep == 1 && (
              <div>
                <div className={`${classes["event-detail-section"]}`}>
                  <div className={`${classes["event-banner-container"]}`}>
                    <p>Event Banner</p>
                    <div className={`${classes["event-banner"]}`}>
                      <EventBannerInput
                        initialValue={bannerImage}
                        fileValue={(value) => {
                          bannerImgChangeHandler({ target: { value } });
                          setBannerImage(value);
                          setEventTypeImageId(null);
                        }}
                        errorText={
                          bannerImgHasError ? "Please select the image" : ""
                        }
                        defaultBanner={bannerImage ? null : defaultBanner}
                        chooseEventImgClickHandler={() =>
                          chooseEventImgClickHandler()
                        }
                        selectedEventType={selectedEventType}
                      // defaultBanner={defaultBanner}
                      />
                    </div>
                  </div>
                  <div className={`${classes["event-det-form"]}`}>
                    <div className={`${classes["event-det-input"]}`}>
                      <InputDropdown
                        label="Select Event Category"
                        disabled={
                          profileDetailsRedux?.userType === "SCHOOL" ||
                            profileDetailsRedux?.userType === "JITO"
                            ? true
                            : false
                        }
                        value={selectedEventType}
                        items={eventTypeList?.map((item) => {
                          return {
                            label: item.name,
                            value: item.id,
                          };
                        })}
                        onSelect={(index, value) => {
                          eventTypeChangeHandler({ target: { value: value } });

                          const selectedEvent =
                            eventTypeList?.filter((item, index) => {
                              return item.id === value;
                            }) || [];
                          const defaultBanner =
                            selectedEvent[0]?.imageList[0]?.image;
                          const defaultBannerId =
                            selectedEvent[0]?.imageList[0]?.id;

                          setEventTypeImageId(defaultBannerId);
                          setDefaultBanner(decryptUrl(defaultBanner));
                          setEventImgDefault(decryptUrl(defaultBanner));
                          if (selectedEvent[0]?.name === "School") {
                            setDefaultDynamicField([
                              {
                                id: uuidv4(),
                                type: "text",
                                questionName: "Parent Name",
                                required: true,
                              },
                              {
                                id: uuidv4(),
                                type: "dropdown",
                                questionName: "Grade",
                                required: true,
                                options: [
                                  "Nursery",
                                  "LKG",
                                  "UKG",
                                  "I",
                                  "II",
                                  "III",
                                  "IV",
                                  "V",
                                  "VI",
                                  "VII",
                                  "VIII",
                                  "IX",
                                  "X",
                                  "XI",
                                  "XII",
                                ],
                              },
                              {
                                id: uuidv4(),
                                type: "text",
                                questionName: "Roll Number",
                                required: true,
                              },
                            ]);
                          }
                        }}
                        // onClose={eventTypeBlurHandler}
                        state={selectedEventTypeHasError ? "error" : "none"}
                        stateConfig={{
                          errorText: "Please select the event type",
                        }}
                      />
                    </div>
                    <div className={`${classes["event-det-input"]}`}>
                      <InputField
                        label="Event Name"
                        value={enteredEventName}
                        onChange={eventNameChangeHandler}
                        // onBlur={eventNameBlurHandler}
                        state={enteredEventNameHasError ? "error" : "none"}
                        stateConfig={{
                          errorText: "Please enter a valid event name",
                        }}
                      />
                    </div>
                    <div className={`${classes["event-det-date"]}`}>
                      <InputDate
                        label="Event start date"
                        name="start-date"
                        datePicker={true}
                        value={startDate}
                        onChange={(value) => {
                          if (isValidYYYYMMDD(value)) {
                            if (!isValidDateRange(value, endDate) && endDate) {
                              endDateChangeHandler({ target: { value: "" } });
                              Notifications.toast.error({
                                title:
                                  "End date cannot be earlier than the start date.",
                                id: "event_end_date",
                              });
                            }
                            startDateChangeHandler({ target: { value } });
                          } else {
                            startDateChangeHandler({ target: { value: "" } });
                          }
                        }}
                        // min={todayDate()}
                        error={startDateHasError}
                        errorText="Please enter the valid date"
                      // value={startDate}
                      />
                    </div>
                    <div className={`${classes["event-det-date"]}`}>
                      <InputDate
                        label="Event end date"
                        // helperText="Helper text"
                        name="end-date"
                        value={endDate}
                        datePicker={true}
                        onChange={(value) => {
                          if (isValidYYYYMMDD(value)) {
                            endDateChangeHandler({ target: { value } });
                          } else {
                            endDateChangeHandler({ target: { value: "" } });
                          }
                        }}
                        error={endDateHasError}
                        errorText="Please enter the valid date"
                        min={startDate}
                      />
                    </div>
                    {startDate === endDate && (
                      <div
                        className={`${classes["event-det-input"]}`}
                        style={{
                          "--spacing-xs": "2px",
                          "--spacing-xxs": "0px",
                        }}>
                        <CustomeTimePicker
                          label="Event Time"
                          placeholder=""
                          slotProps={{
                            textField: {
                              variant: "standard",
                              sx: {
                                "& .MuiFormLabel-root ": {
                                  paddingLeft: "8px",
                                },
                                // "&. MuiInputBase-input": {
                                //   paddingBottom: "32px",
                                // },
                                "& .MuiInputLabel-root.MuiInputLabel-shrink": {
                                  padding: "0px",
                                  fontFamily: "var(--font-families-body-xs)",
                                  fontSize: "18px",
                                },
                                "& .MuiInputBase-input": {
                                  paddingBottom: "10px",
                                },

                                // ✅ force red underline when error
                                "& .MuiInput-underline": timeHasError && {
                                  "&:before": {
                                    borderBottomColor: "red",
                                  },
                                  "&:after": {
                                    borderBottomColor: "red",
                                  },
                                },
                              },
                            },
                            inputAdornment: {
                              sx: {
                                marginRight: "15px",
                                marginBottom: "10px",
                              },
                            },
                          }}
                          slots={{
                            openPickerIcon: () => (
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none">
                                <path
                                  d="M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17317C0.00433284 8.00043 -0.193701 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8079C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7363 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0ZM11 11C11 11.2652 10.8946 11.5196 10.7071 11.7071C10.5196 11.8946 10.2652 12 10 12H7C6.73479 12 6.48043 11.8946 6.2929 11.7071C6.10536 11.5196 6 11.2652 6 11C6 10.7348 6.10536 10.4804 6.2929 10.2929C6.48043 10.1054 6.73479 10 7 10H9V7C9 6.73478 9.10536 6.48043 9.2929 6.29289C9.48043 6.10536 9.73479 6 10 6C10.2652 6 10.5196 6.10536 10.7071 6.29289C10.8946 6.48043 11 6.73478 11 7V11Z"
                                  fill="var(--color-primary-60)"
                                />
                              </svg>
                            ),
                          }}
                          onChange={(value) => {
                            timeChangeHandler({ target: { value } });
                          }}
                          errorMsg={
                            timeHasError ? " Please selcet the time" : ""
                          }
                          value={time || null}
                        />
                      </div>
                    )}
                    <div className={`${classes["event-det-input"]}`}>
                      <LocationInput
                        value={location}
                        onChange={(value) => {
                          locationChangeHandler(value);
                        }}
                        state={locationHasError ? "error" : "none"}
                        stateConfig={{
                          errorText: "Please enter a valid location",
                        }}
                        onLocationSelect={(data) => {
                          setLocationData(data);
                          locationChangeHandler({
                            target: { value: data?.name },
                          });

                          // locationChangeHandler(data.name);
                        }}
                      // value={locationData.name}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
            {formStep == 2 && (
              <div className={`${classes["event-access-container"]}`}>
                <div className={`${classes["access-section"]}`}>
                  <div className={`${classes["access-info"]}`}>
                    <p className={`${classes["access-title"]}`}>Event Type</p>
                    <p className={`${classes["access-dec"]}`}>
                      Control how guests can join the event
                    </p>
                  </div>
                  <div className={`${classes["access-input-container"]}`}>
                    <div
                      className={`${classes["access-input-card"]} ${isOpenEvent ? classes["active"] : classes["unactive"]}`}
                      onClick={() => {
                        setIsOpenEvent(true);
                      }}>
                      <div className={`${classes["icon"]}`}>
                        <Icon ic={"IcGlobe"} kind="background" size="large" />
                      </div>
                      <div className={`${classes["input-card-info"]}`}>
                        <p className={`${classes["input-card-title"]}`}>
                          Public
                        </p>
                        <p className={`${classes["input-card-dec"]}`}>
                          Anyone with QR can join
                        </p>
                      </div>
                    </div>
                    <div
                      className={`${classes["access-input-card"]} ${!isOpenEvent ? classes["active"] : classes["unactive"]}`}
                      onClick={() => {
                        setIsOpenEvent(false);
                      }}>
                      <div className={`${classes["icon"]}`}>
                        <Icon ic={"IcLock"} kind="background" size="large" />
                      </div>
                      <div className={`${classes["input-card-info"]}`}>
                        <p className={`${classes["input-card-title"]}`}>
                          Private
                        </p>
                        <p className={`${classes["input-card-dec"]}`}>
                          Registration approval required
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={`${classes["access-section"]}`}>
                  <div className={`${classes["access-info"]}`}>
                    <p className={`${classes["access-title"]}`}>Photo Access</p>
                    <p className={`${classes["access-dec"]}`}>
                      Control how guests can view photos from the event
                    </p>
                  </div>
                  <div className={`${classes["access-input-container"]}`}>
                    <div
                      className={`${classes["access-input-card"]} ${defaultAccess === "FACE_ACCESS" ? classes["active"] : classes["unactive"]}`}
                      onClick={() => {
                        setDefaultAccess("FACE_ACCESS");
                      }}>
                      <div className={`${classes["icon"]}`}>
                        <Icon
                          ic={"IcScanFace"}
                          kind="background"
                          size="large"
                        />
                      </div>
                      <div className={`${classes["input-card-info"]}`}>
                        <p className={`${classes["input-card-title"]}`}>
                          Face Access
                        </p>
                        <p className={`${classes["input-card-dec"]}`}>
                          Guests can see only their photos
                        </p>
                      </div>
                    </div>
                    <div
                      className={`${classes["access-input-card"]} ${defaultAccess === "FULL_ACCESS" ? classes["active"] : classes["unactive"]} `}
                      onClick={() => {
                        setDefaultAccess("FULL_ACCESS");
                      }}>
                      <div className={`${classes["icon"]}`}>
                        <Icon ic={"IcPhoto"} kind="background" size="large" />
                      </div>
                      <div className={`${classes["input-card-info"]}`}>
                        <p className={`${classes["input-card-title"]}`}>
                          Full Access
                        </p>
                        <p className={`${classes["input-card-dec"]}`}>
                          Guests can see all photos in event
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={`${classes["access-section"]}`}>
                  <div className={`${classes["access-info"]}`}>
                    <p className={`${classes["access-title"]}`}>
                      Upload Access
                    </p>
                    <p className={`${classes["access-dec"]}`}>
                      Allow guests to upload their own photos to the event
                    </p>
                  </div>
                  <div className={`${classes["access-input-container"]}`}>
                    <div
                      className={`${classes["yes-no-card"]} ${defaultUploadAccess === "APPROVED" ? classes["yes-active"] : classes["unactive"]}`}
                      onClick={() => {
                        setDefaultUploadAccess("APPROVED");
                      }}>
                      <p className={`${classes["title"]}`}>Yes</p>
                      <p className={`${classes["dec"]}`}>Enabled</p>
                    </div>
                    <div
                      className={`${classes["yes-no-card"]} ${defaultUploadAccess === "REJECTED" ? classes["no-active"] : classes["unactive"]}`}
                      onClick={() => {
                        setDefaultUploadAccess("REJECTED");
                      }}>
                      <p className={`${classes["title"]}`}>No</p>
                      <p className={`${classes["dec"]}`}>Disabled</p>
                    </div>
                  </div>
                </div>
                <div className={`${classes["access-section"]}`}>
                  <div className={`${classes["access-info"]}`}>
                    <p className={`${classes["access-title"]}`}>
                      Download Access
                    </p>
                    <p className={`${classes["access-dec"]}`}>
                      Allow guests to download photos from the event
                    </p>
                  </div>
                  <div className={`${classes["access-input-container"]}`}>
                    <div
                      className={`${classes["yes-no-card"]}  ${defaultDownloadAccess === "APPROVED" ? classes["yes-active"] : classes["unactive"]}`}
                      onClick={() => {
                        setDefaultDownloadAccess("APPROVED");
                      }}>
                      <p className={`${classes["title"]}`}>Yes</p>
                      <p className={`${classes["dec"]}`}>Enabled</p>
                    </div>
                    <div
                      className={`${classes["yes-no-card"]} ${defaultDownloadAccess === "REJECTED" ? classes["no-active"] : classes["unactive"]}`}
                      onClick={() => {
                        setDefaultDownloadAccess("REJECTED");
                      }}>
                      <p className={`${classes["title"]}`}>No</p>
                      <p className={`${classes["dec"]}`}>Disabled</p>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {formStep == 3 && (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                }}>
                <DynamicForm
                  setDefaultDynamicField={setDefaultDynamicField}
                  defaultDynamicField={defaultDynamicField}
                // disabled={eventCreating}
                />
              </div>
            )}
          </div>
          <div className={`${classes["form-footer"]}`}>
            <ActionButton
              kind="secondary"
              label="Back"
              onClick={() => {
                if (formStep > 1) {
                  setFormStep((pre) => pre - 1);
                }
              }}
              state={formStep <= 1 ? "disabled" : "normal"}
            />
            <div className={`${classes["steps-count"]}`}>
              {" "}
              Setp {formStep} of 3
            </div>
            <ActionButton
              kind="primary"
              label={formStep === 3 ? "Create Event" : "Next"}
              onClick={() => {
                if (!eventListGeting && !eventCreating) {
                  if (formStep === 1) {
                    formSubmitHandler();
                  }
                  if (formStep === 2) {
                    setFormStep((pre) => pre + 1);
                  }
                  if (formStep === 3) {
                    handleCreateEvent();
                  }
                }
              }}
            />
          </div>
        </div>
      </div>
      <JdsModal
        size="m"
        // header="Event Banner"
        kind="dialog"
        primaryCTA={{
          title: "Next",
        }}
        secondaryCTA={{
          title: "Cancel",
        }}
        close={isEventTypeGalleryModalClose}
        onClose={() => {
          eventBannerGalleryModalCloseHandler();
        }}
        onPrimaryClick={() => {
          eventBannerGalleryModalCloseHandler();
        }}
        onSecondaryClick={() => {
          eventBannerGalleryModalCloseHandler();
        }}
        primaryCtaDisabled={currentIndex == null}>
        <Container direction="column" fullWidth>
          <Box direction="column">
            <Text text="Choose event banner" appearance="heading-xs" />
            {/* <Text text="Choose an image for the event banner" appearance="body-s" color="primary-grey-80" /> */}
          </Box>
          {!isEventTypeGalleryModalClose && (
            <Box sx={{ width: "100%" }} mt={2} p={0.5}>
              <ImageGrid
                emptyGrid={selectedEventType ? false : true}
                images={eventTypeList
                  ?.find((val) => val.id === selectedEventType)
                  ?.imageList.map((data) => ({
                    thumbnailFileSignedPath: data?.image,
                  }))}
                setCurrIndex={(index) => {
                  setCurrIndex(index);
                  const eventTypeImgList = eventTypeList?.find(
                    (val) => val.id === selectedEventType,
                  )?.imageList;
                  setEventTypeImageId(eventTypeImgList[index]?.id);
                  setDefaultBanner(decryptUrl(eventTypeImgList[index]?.image));
                  // setEventImgDefault(decryptUrl(eventTypeImgList[index]?.image));
                }}
                currentIndex={currentIndex}
                selectImg={true}
                param={false}
              />
            </Box>
          )}
        </Container>
      </JdsModal>{" "}
    </>
  );
};
export default CreateNewEvent;
